import { useRef, useEffect } from 'react';
import Raven from 'raven-js';
const createResizeObserver = onSizeChange => {
  try {
    return new ResizeObserver(entries => {
      const [entry] = entries;
      if (!entry.target) {
        return;
      }
      const height = entry.target.clientHeight;
      const width = entry.target.clientWidth;
      if (onSizeChange) {
        onSizeChange({
          height,
          width
        });
      }
    });
  } catch (error) {
    Raven.captureMessage(`Couldn't create ResizeObserver: ${error}`);
  }
  return undefined;
};
const useResizeObserver = (elementRef, onSizeChange) => {
  const observer = useRef(createResizeObserver(onSizeChange));
  useEffect(() => {
    if (elementRef && elementRef.current && observer.current) {
      observer.current.observe(elementRef.current);
    }
    return () => {
      if (elementRef.current && observer.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.current.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);
};
export default useResizeObserver;